import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import CustomText from "pages/_components/CustomText/CustomText";
import Credential from "pages/_components/fields/credentials/Credential";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Checkbox from "pages/_components/Checkbox";

import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import * as i18n from "util/i18n";
import Notification from "pages/_components/Notification";
import CustomData from "pages/_components/CustomData/CustomData";
import { bool, string } from "prop-types";
import { goBack, push } from "connected-react-router";
import { actions as discountsActions } from "reducers/discounts";
import Button from "pages/_components/Button";
import { Col, Row } from "react-bootstrap";
import { actions as softTokenActions, selectors as softTokenSelectors } from "reducers/softToken";
import gaEventTracker, { events } from "util/gaEventTracker";
import { actions as settingsActions } from "reducers/settings";
import { actions as depositsActions } from "reducers/deposits";
import EcheqItem from "../DiscountCreation/components/ItemRow";
import EcheqList from "../DiscountCreation/components/List";
import TitleColumns from "../DiscountCreation/components/TitleColumns";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";

const CATEGORY = "discountEcheq";

const DiscountReviewPage = ({ isDesktop, deviceStatus }) => {
    const [statusChecked, setStatusChecked] = useState(false);
    const {
        discountSimulation,
        discountStatus,
        newDiscount,
        listEcheq,
        discountRequiredCredentials,
        discountTicket,
    } = useSelector((_state) => _state.discounts);
    const { status: discountTicketStatus, idTransaction: discountTicketId } = discountTicket;
    const { totalEffectiveAmount: simulationEffectiveAmount, totalAmount: simulationAmount } = discountSimulation;
    const [echeqs, setEcheqs] = useState([]);
    const accounts = useSelector((_state) => _state.accounts?.accounts);
    const [accountLabel, setAccountLabel] = useState(null);
    const dispatch = useDispatch();
    const row = isDesktop ? 1 : 6;
    const { documents } = useSelector((state) => state.settings);

    const data = {
        account: newDiscount.account,
        amount: {
            quantity: simulationEffectiveAmount?.quantity || 0,
            currency: simulationEffectiveAmount?.currency || "ARS",
        },
        amountTotal: {
            quantity: simulationAmount?.quantity || 0,
            currency: simulationAmount?.currency || "ARS",
        },
        option: "discount.echeqs",
        isOwnEcheq: newDiscount.isOwnEcheq,
        idActivity: newDiscount?.isOwnEcheq === true ? "openLot.ownEcheq.send" : "load.echeq.discounts",
    };

    useEffect(() => {
        console.log("statusChecked ", statusChecked);
        console.log("discountStatus ", discountStatus);
        if (!statusChecked) {
            if (discountStatus !== "REVIEW_DISCOUNT") {
                dispatch(push("/discounts"));
            }
            setStatusChecked(true);
        } else if (discountStatus === "SIMULATING_DISCOUNT") {
            dispatch(push("/discounts/simulation"));
        } else if (discountStatus !== "REVIEW_DISCOUNT") {
            dispatch(discountsActions.setDiscountStatus("REVIEW_DISCOUNT"));
        }
    }, [discountStatus, statusChecked, dispatch]);

    useEffect(
        () => () => {
            dispatch(discountsActions.restartDiscountStatus("SIMULATING_DISCOUNT", "REVIEW_DISCOUNT"));
            dispatch(softTokenActions.getTokenInfo());
        },
        [],
    );

    useEffect(() => {
        if (accounts && newDiscount && !accountLabel) {
            const selectedAccount = accounts?.find((account) => account.productId === newDiscount?.account?.idProduct);

            setAccountLabel(
                `${i18n.get(
                    `productType.${selectedAccount?.accountType}`,
                    "",
                )} ····${selectedAccount?.accountNumber?.slice(-4)} ${selectedAccount?.accountType} ${i18n.get(
                    `currency.label.${selectedAccount?.currency}`,
                    "",
                )}` || "Error obteniendo la cuenta",
            );
        }
    }, [accounts, newDiscount, accountLabel, setAccountLabel]);

    useEffect(() => {
        if (listEcheq && newDiscount && !echeqs.length) {
            setEcheqs(
                newDiscount.echeqList?.map((selectedEcheq) =>
                    listEcheq.find((echeq) => selectedEcheq.cheque_id === echeq.cheque_id),
                ),
            );
        }
    }, [listEcheq, newDiscount, echeqs, setEcheqs]);

    useEffect(() => {
        const validTransactionStatus = ["PENDING", "PROCESSING", "FINISHED", "FAILED"];

        if (validTransactionStatus.includes(discountTicketStatus) && discountTicketId) {
            gaEventTracker.triggerEvent(events.echeq_enviar());
            dispatch(depositsActions.acceptTermDeposit(discountTicketId, CATEGORY));
            dispatch(push(`/transaction/${discountTicketId}`));
        }
    }, [discountTicketStatus, discountTicketId]);

    const onBack = () => {
        dispatch(discountsActions.setDiscountStatus("SIMULATING_DISCOUNT"));
        dispatch(goBack());
    };

    return (
        <>
            <Notification scopeToShow="DiscountReviewPage" />
            <ResponsiveHeader defaultTitle="Descuento de Echeqs" onClickBack={onBack} />
            <MainContainer className="discounts-echeq-review">
                <div className="container">
                    <CustomText
                        text="discount.data.review.title"
                        textType="I18N"
                        className="discounts-echeq-review__date-control"
                    />
                    <GridTable className="deposits-details-list details">
                        <GridTable.Container columns={isDesktop ? 4 : 1} rows={isDesktop ? 1 : 4}>
                            <GridTable.Data columnStart={1} rowStart={1}>
                                <CustomData
                                    titleText={i18n.get("", "Cuenta de acreditación")}
                                    titleClass="text-Primary-primary-color"
                                    valueText={accountLabel}
                                />
                            </GridTable.Data>
                            <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                                <CustomData
                                    titleText={i18n.get("", "Monto total")}
                                    valueText={simulationAmount?.quantity || 0}
                                    valueTextType={simulationAmount?.currency}
                                />
                            </GridTable.Data>
                            <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3}>
                                <CustomData
                                    titleText={i18n.get("", "Monto a acreditar")}
                                    valueText={simulationEffectiveAmount?.quantity || 0}
                                    valueTextType={simulationEffectiveAmount?.currency}
                                />
                            </GridTable.Data>
                            <GridTable.Data columnStart={isDesktop ? 4 : 1} rowStart={isDesktop ? 1 : 4}>
                                <CustomData titleText={i18n.get("", "Cantidad de Echeq")} valueText={echeqs?.length} />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable>
                    <EcheqList
                        fetchingWithPreviousData
                        items={echeqs || []}
                        noDataText="global.no.results"
                        noFiltersDataText="debin.global.no.results"
                        renderItem={(item) => (
                            <GridTable.Container
                                key={`echeq-item-${item?.cheque_id}`}
                                className={!isDesktop && "box box-shadow"}>
                                <EcheqItem
                                    key={`transaction-${item?.cheque_id}`}
                                    receibedEcheq={item}
                                    isDesktop={isDesktop}
                                    canCheck={false}
                                />
                            </GridTable.Container>
                        )}>
                        {(listItem) => (
                            <GridTable className="tablelist debin-table">
                                <GridTable.Header>
                                    <GridTable.Container rows={row}>
                                        <TitleColumns canCheck={false} />
                                    </GridTable.Container>
                                </GridTable.Header>
                                <GridTable.Body>{listItem}</GridTable.Body>
                            </GridTable>
                        )}
                    </EcheqList>
                    <div className="container--alert" role="alert">
                        <div className="alert alert-info">
                            <CustomData
                                icon="information_fill.svg"
                                titleText={i18n.get(
                                    "",
                                    // eslint-disable-next-line max-len
                                    "Recordá que las operaciones para descontar tus Echeq se deberán realizar los días hábiles desde las 10:00 hasta las 15:00 hs.",
                                )}
                                keepSpaceIfNoValue={false}
                            />
                        </div>
                        <div style={{ paddingBottom: "10px" }} />
                    </div>
                </div>
                {/* <div className="discounts-echeq-simulation__rate">
                    <CustomText
                        text={`* ${i18n.get(
                            "discounts.amountToCredit.disclaimer",
                            "Monto a acreditar sujeto a impuesto de sellos e IIBB.",
                        )}`}
                    />
                </div> */}

                <Formik
                    // ref={(el) => setFormRef(el)}
                    validateOnBlur
                    validateOnChange={false}
                    initialValues={{
                        termAndConditions: false,
                    }}
                    validationSchema={Yup.object().shape({
                        termAndConditions: Yup.bool()
                            .test(
                                "is-true",
                                i18n.get("forms.inputFile.massivePayments.invalid.required"),
                                (value) => !!value,
                            )
                            .required(i18n.get("forms.inputFile.massivePayments.invalid.required")),
                    })}>
                    {({ setFieldValue, values }) => (
                        <>
                            <Row className="form-actions">
                                <Col xs={12} md={10}>
                                    <div className="discounts-echeq-review__form-actions">
                                        <Field
                                            component={Checkbox}
                                            idForm="discounts.new.lastForm"
                                            name="termAndConditions"
                                            labelText="discounts.new.review.termAndConditions.label"
                                            labelTextProps={{ defaultValue: "Leé y aceptá los\u00A0" }}
                                        />
                                        <Button
                                            block
                                            className="btn btn-link discounts-echeq-review__form-actions-terms"
                                            onClick={() => {
                                                setFieldValue("termAndConditions", !values?.termAndConditions, false);
                                                dispatch(
                                                    settingsActions.downloadDocumentRequest(
                                                        documents[0]?.fileNameKey,
                                                        CATEGORY,
                                                    ),
                                                );
                                            }}
                                            defaultLabelText="Términos y Condiciones"
                                        />
                                    </div>
                                </Col>

                                <GeneralCredentialForm
                                    transactionData={data}
                                    action={discountsActions.createDiscount}
                                    idActivity={
                                        newDiscount?.isOwnEcheq === true
                                            ? "openLot.ownEcheq.send"
                                            : "load.echeq.discounts"
                                    }
                                    hideIndications
                                    disableContinueIfEmpty
                                    isDisabled={values?.termAndConditions === false}
                                />
                            </Row>
                        </>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

DiscountReviewPage.propTypes = {
    isDesktop: bool.isRequired,
    deviceStatus: string.isRequired,
    // tokenInfo: shape({}).isRequired,
};
const mapStateToProps = (state) => ({
    // tokenInfo: softTokenSelectors.getTokenInfo(state),
    deviceStatus: softTokenSelectors.getDeviceStatus(state),
});
export default connect(mapStateToProps)(DiscountReviewPage);
